<template>
  <div class="sourcetype-select">
    <el-select
      v-model="selectValue"
      collapse-tags
      multiple
      placeholder="全部"
      popper-class="sourcetype-select__box"
    >
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { getSource } from '@/api/ai-board'
import { AllSourceTypeMap } from '@/constants/source-type-map'
import { useRoute } from 'vue-router'

const route = useRoute()
defineOptions({
  name: 'SourceTypeSelect'
})

const props = defineProps({
  value: {
    type: [Number, String],
    default: ''
  }
})

const emits = defineEmits(['update:value', 'change'])

const options = ref([])

const selectValue = computed({
  get() {
    return props.value
  },
  set(newValue) {
    emits('update:value', newValue)
    emits('change', newValue)
  }
})

onMounted(async () => {
  try {
    const res = await getSource()
    const result = res.result || {}
    // TODO: 兼容特殊业务场景【员工跟进日程、员工跟进Pk】看板下，不展示【群聊Tab】
    const hasWechatGroup = !['meetingAssessment', 'userFollowSchedule'].includes(route.name)
    options.value = AllSourceTypeMap.filter(({ key }) => result[key] === 1).filter((val) => {
      return val.value === 11 ? hasWechatGroup : true
    })
  } catch (e) {
    options.value = [{ value: 1, label: '手动上传音视频' }]
    // 可选：如需提示可引入ElMessage.error('获取来源失败')
  }
})
</script>

<style lang="scss" scoped>
.sourcetype-select {
}
</style>
